// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  body * {
    visibility: hidden;
    font-family: "Times New Roman", Times, serif;
  }
  .hideBtn {
    display: none;
  }
  #hideDate {
    display: none;
  }
  #divToPrintCounselCauseList,
  #divToPrintCounselCauseList * {
    visibility: visible;
  }
  #divToPrintCounselCauseList {
    position: absolute;
    left: 0;
    top: 0;
    zoom: 150%;
    font-size: 20px;
    page-break-inside: avoid;
  }
  .counselListHeading {
    page-break-after: always;
  }
  .counselMainHeading {
    page-break-after: avoid !important;
    page-break-inside: avoid !important;
  }
}

#divToPrintCounselCauseList table {
  border: 1px solid black !important;
}

#divToPrintCounselCauseList th,
#divToPrintCounselCauseList td {
  border: 1px solid black !important;
}

/* Allow long heading text to wrap and break on both screen and print */
.counselListHeading th,
.heading-cell {
  white-space: normal !important; /* allow wrapping */
  overflow-wrap: anywhere; /* break long words if needed */
  word-break: break-word; /* fallback for some browsers */
  hyphens: auto; /* enable hyphenation where supported */
}

/* Reduce very large print zoom side effects by limiting long header font-size on print */
@media print {
  .heading-cell {
    font-size: 0.95em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/causeList/printCounselCauseList.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB;IAClB,4CAA4C;EAC9C;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;IACV,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kCAAkC;IAClC,mCAAmC;EACrC;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,uEAAuE;AACvE;;EAEE,8BAA8B,EAAE,mBAAmB;EACnD,uBAAuB,EAAE,+BAA+B;EACxD,sBAAsB,EAAE,+BAA+B;EACvD,aAAa,EAAE,uCAAuC;AACxD;;AAEA,yFAAyF;AACzF;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@media print {\n  body * {\n    visibility: hidden;\n    font-family: \"Times New Roman\", Times, serif;\n  }\n  .hideBtn {\n    display: none;\n  }\n  #hideDate {\n    display: none;\n  }\n  #divToPrintCounselCauseList,\n  #divToPrintCounselCauseList * {\n    visibility: visible;\n  }\n  #divToPrintCounselCauseList {\n    position: absolute;\n    left: 0;\n    top: 0;\n    zoom: 150%;\n    font-size: 20px;\n    page-break-inside: avoid;\n  }\n  .counselListHeading {\n    page-break-after: always;\n  }\n  .counselMainHeading {\n    page-break-after: avoid !important;\n    page-break-inside: avoid !important;\n  }\n}\n\n#divToPrintCounselCauseList table {\n  border: 1px solid black !important;\n}\n\n#divToPrintCounselCauseList th,\n#divToPrintCounselCauseList td {\n  border: 1px solid black !important;\n}\n\n/* Allow long heading text to wrap and break on both screen and print */\n.counselListHeading th,\n.heading-cell {\n  white-space: normal !important; /* allow wrapping */\n  overflow-wrap: anywhere; /* break long words if needed */\n  word-break: break-word; /* fallback for some browsers */\n  hyphens: auto; /* enable hyphenation where supported */\n}\n\n/* Reduce very large print zoom side effects by limiting long header font-size on print */\n@media print {\n  .heading-cell {\n    font-size: 0.95em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
